
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { RolesEnum, policyChecker, extractRoles } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";

@Component
export default class RequireRole extends Vue {
  @Prop()
  policy?: string;
  @Prop()
  policies?: string[];
  @Prop()
  role?: string;
  @Prop()
  roles?: string[];

  @Getter("auth/claims")
  claims?: JwtClaims;

  render() {
    const requiredPolicies = this.policies ?? [];
    if (this.policy) {
      requiredPolicies.push(this.policy);
    }

    if (requiredPolicies.length > 0) {
      return this.conditionalRender(requiredPolicies.some((x) => policyChecker(x)(this.claims)));
    } else {
      const myRoles = extractRoles(this.claims);
      const requiredRoles = this.roles ?? [];
      if (this.role) {
        requiredRoles.push(this.role);
      }

      const exists =
        requiredRoles.length === 0 ||
        myRoles.some((myRole) =>
          requiredRoles.some((r) => RolesEnum[myRole] === r)
        );

      return this.conditionalRender(exists);
    }
  }

  conditionalRender(x: boolean) {
    return x ? this.$slots.default : undefined;
  }
}
